import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import { filterOptions, ModuleNameReverseMap } from "src/common/constants";
import procedureJobDataAccess from "src/dataAccess/procedures/procedureJobDataAccess";
import productbatchcodedataaccess from "src/dataAccess/products/productbatchcodedataaccess";

interface IListType {
  pageNo: number;
  pageSize: number;
  sortData: string;
  filters: any[];
}
interface jobListType extends IListType {
  typeProcedure: number;
  isAuditBySupplier: boolean;
  isArchived: boolean;
  hasDiscrepancies?: boolean;
  verifiyNeeded?: boolean;
  supplierId?: number;
}

export const loadingProcedureJob = createAction<boolean>(
  "[Procedure Job] Loading procedure Job list"
);

export const getListActionSuccess = createAction<any>(
  "[Procedure Job] Get Procdure Job list Success"
);
export const updatePostAuditEvent = createAction<any>(
  "[Procedure Job] Update Post Audit Event list Success"
);

export const AddPostAuditEvent = createAction<any>(
  "Add Post Audit Event Success"
);
export const RemovePostAuditEvents = createAction<any>(
  "Remove Post Audit Event Success"
);

export const getListActionAsync = createAsyncThunk<string, jobListType>(
  "[Procedure Job] Get Procedure Job list",
  async (parameter: jobListType, thunkAPI) => {
    let moduleName: string;
    switch (parameter.typeProcedure) {
      case 0:
        moduleName = ModuleNameReverseMap["View Completed Checks"];
        break;
      case 1:
        moduleName = ModuleNameReverseMap["Completed Goods In"];
        break;
      case 2:
        moduleName = ModuleNameReverseMap["Completed Recipes"];
        break;
      case 3:
        moduleName = ModuleNameReverseMap["Completed Dispatches"];
        break;
      case 5:
        moduleName = ModuleNameReverseMap["Completed Courses"];
        break;
      case 7:
        moduleName = ModuleNameReverseMap["Completed Audits"];
        break;
      default:
        moduleName = ModuleNameReverseMap["View Completed Checks"];
        break;
    }
    thunkAPI.dispatch(loadingProcedureJob(true));

    var filter = {
      propertyName: "TypeProcedure",
      value: parameter.typeProcedure.toString(),
      type: filterOptions.equals.value,
    };
    var filterIsArchied = {
      propertyName: "IsArchived",
      value: parameter.isArchived.toString(),
      type: filterOptions.equals.value,
    };
    console.log(parameter);
    var filterIsAuditBySupplier = {
      propertyName: "IsAuditBySupplier",
      value: parameter.isAuditBySupplier.toString(),
      type: filterOptions.equals.value,
    };
    if (parameter.supplierId > 0) {
      var filterSupplier = {
        propertyName: "SupplierId",
        value: parameter.supplierId.toString(),
        type: filterOptions.equals.value,
      };
      parameter.filters = parameter.filters.concat(filterSupplier);
    }
    parameter.filters = parameter.filters.concat(filter);
    parameter.filters = parameter.filters.concat(filterIsArchied);
    parameter.filters = parameter.filters.concat(filterIsAuditBySupplier);
    if (parameter.verifiyNeeded) {
      var VerifiyNeeded = {
        propertyName: "VerifiyNeeded",
        value: parameter.verifiyNeeded.toString(),
        type: filterOptions.equals.value,
      };
      parameter.filters = parameter.filters.concat(VerifiyNeeded);
    }
    if (parameter.hasDiscrepancies) {
      var filterHasDiscrepancies = {
        propertyName: "HasDiscrepancies",
        value: parameter.hasDiscrepancies.toString(),
        type: filterOptions.equals.value,
      };
      parameter.filters = parameter.filters.concat(filterHasDiscrepancies);
    }
    const result = await procedureJobDataAccess
      .getList(parameter, moduleName)
      .then((res) => {
        thunkAPI.dispatch(loadingProcedureJob(false));
        thunkAPI.dispatch(getListActionSuccess(res));
        return res;
      });
    return result;
  }
);
// export const getQurantineListSuccess = createAction<any>(
//   "[Qurantine] Get Qurantine List Success"
// );
// export const loadingList = createAction<boolean>("[Qurantine] Loading list");
// export const GetQurantineList = createAsyncThunk<any, IListType>(
//   "[Qurantine] Get Qurantine List",
//   async (parameter, thunkAPI) => {
//     thunkAPI.dispatch(loadingList(true));
//     const result = await productbatchcodedataaccess.getData(parameter).then((res) => {
//       console.log(res.data);
//       thunkAPI.dispatch(getQurantineListSuccess(res));
//       thunkAPI.dispatch(loadingList(false));
//       return res;
//     });
//     return result;
//   }
// );
